// Cookie helper functions
function setCookie(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + value + '; expires=' + expires + '; path=/';
}

function getCookie(name) {
  return document.cookie.split('; ').reduce(function(acc, c) {
    var parts = c.split('=');
    return parts[0] === name ? parts[1] : acc;
  }, null);
}

// Open popup
document.querySelector(".popup-custom-btn").addEventListener('click', function (e) {
  e.stopPropagation();
  document.querySelector(".popup-custom").style.display = 'block';
}, false);

document.querySelector(".popup-custom-btn").addEventListener('click', function () {
  document.querySelector(".popup-custom-overlay").style.display = 'block';
}, false);

// Close popup + set cookie
function closePopup() {
  document.querySelector(".popup-custom").style.display = 'none';
  document.querySelector(".popup-custom-overlay").style.display = 'none';
  setCookie('popupSeen', '1', 7); // Set 7-day cookie on close
}

document.querySelector(".popup-custom-close").addEventListener('click', closePopup, false);
document.querySelector("body").addEventListener('click', closePopup, false);

document.querySelector(".popup-custom").addEventListener('click', function (e) {
  e.stopPropagation();
}, false);

// Only auto-trigger if cookie is not set
if (!getCookie('popupSeen')) {
  setTimeout(function () {
    document.querySelector(".popup-custom-btn").click();
  }, 3000);
}